import {
  Button,
  TextField,
  withTheme
} from "@material-ui/core";
import * as React from "react";
import { isEmail } from "validator";
import ContentCard from "../sharedComponents/ContentCard";
import s from "./forgotPasswordInitiate.module.css";

import globalContext from "../../context/globalContext";

class PassLogin extends React.Component {
  static contextType = globalContext;
  constructor(props) {
    super(props);
    this.state = {
      email: "",

      error: false,
      labelText: "email",
      submitted: false,
      showPassword: false,
      helperText: "",
      errorText: ""
    };
  }

  handleChange = event => {
    let target = event.target;

    // if (!isEmail(target.value) && this.state.submitted) {
    //   this.setState({ error: true, labelText: "Must be a valid email" });
    // } else {
    //   this.setState({ error: false, labelText: "email" });
    // }
    this.setState({
      [target.name]: target.value,
      error: false,
      labelText: "email"
    });
  };

  handleClickShowPassword = () => {
    this.setState(state => ({ showPassword: !this.state.showPassword }));
  };

  render() {
    const { email, error, labelText } = this.state;
    const { errorSnackbarState } = this.context.global.data;

    if (errorSnackbarState) {
    }

    return (
      <ContentCard>
        <div className={s.container}>
          <h1 style={{ fontFamily: "'Montserrat', sans-serif" }}>
            Reset Password
          </h1>
          <p>
            Enter your email below and we will send you a reset link to change
            your password.
          </p>
          <div className={s.middle}>
            <TextField
              name={"email"}
              placeholder={"email"}
              value={email}
              error={error}
              label={labelText}
              onChange={this.handleChange}
              autoCapitalize="none"
              autoCorrect="none"
              margin="normal"
            />
          </div>
          <div className={s.bottom}>
            <Button
              onClick={() => {
                if (isEmail(email) && email.length > 0) {
                  this.context.global
                    .initiateForgotPassword(email.toLowerCase())
                    .then(res => {
                      this.props.history.replace(`/login`);

                      this.context.global.setGlobalState(
                        "successSnackbarText",
                        res.message
                      );
                      this.context.global.setGlobalState(
                        "successSnackbarState",
                        true
                      );
                    })
                    .catch(err => {
                      this.setState({
                        error: true,
                        errorText: "Something went wrong.",
                        submitted: true
                      });
                    });
                } else {
                  this.setState({
                    error: true,
                    labelText: "Must be valid email",
                    helperText: "You need to specify a valid email ",
                    submitted: true
                  });
                }
              }}
            >
              Send me a reset link
            </Button>

            <div
              style={{
                display: "flex",
                fontSize: "small",
                flex: "space-around"
              }}
            >
              <p
                onClick={() => this.props.history.replace("/login")}
                style={{
                  textDecoration: "underline",
                  textAlign: "right",
                  fontFamily: "Montserrat"
                }}
              >
                Login
              </p>
              <div style={{ flex: 1 }} />
              <p
                onClick={() => this.props.history.replace("/register")}
                style={{
                  textDecoration: "underline",
                  textAlign: "right",
                  fontFamily: "Montserrat"
                }}
              >
                Register
              </p>
            </div>
            <div className={s.legalLine}>
              <p
                onClick={() => this.props.history.push("/privacy-policy")}
                style={{
                  textDecoration: "underline",
                  textAlign: "center",
                  fontFamily: "Montserrat",
                  marginTop: 20,
                  marginBottom: 0,
                  fontSize: 12,
                  maxWidth: 100,
                  alignSelf: "center"
                }}
              >
                Privacy Policy
              </p>
              <p
                style={{
                  textDecoration: "underline",
                  textAlign: "center",
                  fontFamily: "Montserrat",
                  marginTop: 20,
                  marginBottom: 0,
                  fontSize: 12,
                  maxWidth: 100,
                  alignSelf: "center"
                }}
              >
                |
              </p>
              <p
                onClick={() => this.props.history.push("/terms-of-service")}
                style={{
                  textDecoration: "underline",
                  textAlign: "center",
                  fontFamily: "Montserrat",
                  marginTop: 20,
                  marginBottom: 0,
                  fontSize: 12,
                  maxWidth: 100,
                  alignSelf: "center"
                }}
              >
                Terms of Service
              </p>
            </div>
          </div>
        </div>
      </ContentCard>
    );
  }
}

export default withTheme()(PassLogin);
